import { getLivekitTransports } from './rtcFoci.js';
import { buildProvisioningRequest } from './callProtocol.js';
const trimTrailingSlash = (value) => value.replace(/\/+$/, '');
export const isLivekitTransportConfig = (transport) => transport.type === 'livekit' && typeof transport.livekit_service_url === 'string';
const isProvisioningResult = (value) => typeof value === 'object' &&
    value !== null &&
    'url' in value &&
    typeof value.url === 'string' &&
    value.url.length > 0 &&
    'jwt' in value &&
    typeof value.jwt === 'string' &&
    value.jwt.length > 0;
export const getPreferredLivekitTransport = async (mx, discovery) => {
    const transports = await mx['_unstable_getRTCTransports']().catch(() => undefined);
    const livekitTransport = transports?.find(isLivekitTransportConfig);
    if (livekitTransport)
        return livekitTransport;
    return getLivekitTransports(discovery)[0];
};
const requestLivekitToken = async ({ url, body }, request) => {
    const response = await request(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (response.status < 200 || response.status >= 300) {
        const error = new Error(`LiveKit provisioning request failed with status ${response.status}`);
        error.status = response.status;
        throw error;
    }
    const data = (await response.json());
    if (!isProvisioningResult(data)) {
        throw new Error('LiveKit provisioning response was invalid');
    }
    return { url: data.url, jwt: data.jwt };
};
export const provisionLivekitToken = async ({ mx, roomId, userId, deviceId, memberId, slotId, stickyMemberships, serviceUrl, request, }) => {
    let openidToken;
    try {
        openidToken = await mx.getOpenIdToken();
    }
    catch {
        throw new Error('Unable to obtain an OpenID token for LiveKit provisioning');
    }
    const endpoint = trimTrailingSlash(serviceUrl);
    const inputs = {
        serviceUrl: endpoint,
        roomId,
        userId,
        deviceId,
        memberId,
        slotId,
        openidToken,
    };
    try {
        return await requestLivekitToken(buildProvisioningRequest(inputs, stickyMemberships), request);
    }
    catch (error) {
        // Report which SFU refused us and with what status, since that separates a
        // dead transport advertised by another participant from a rejected token.
        // Never forward the underlying message or cause: the request body carries
        // the OpenID token and the response carries the issued JWT.
        const status = error?.status;
        // oxlint-disable-next-line preserve-caught-error -- attaching the cause leaks the tokens
        throw new Error(status === undefined
            ? `LiveKit token provisioning failed against ${endpoint}`
            : `LiveKit token provisioning failed against ${endpoint} with status ${status}`);
    }
};
//# sourceMappingURL=livekitProvisioning.js.map